export const formatPrice = (price, currency = "EUR", lang = "it-IT") => {
  if ((price || price === 0) && lang !== "tr-TR") {
    const formattedPrice = Intl.NumberFormat(lang, {
      style: "currency",
      currency,
    }).format(parseFloat(price.toString().replace(",", ".")));
    return formattedPrice;
  }
  if ((price || price === 0) && lang === "tr-TR") {
    const formattedPrice = Intl.NumberFormat(lang, {
      style: "currency",
      currency,
    }).format(parseFloat(price.toString().replace(",", ".")));
    return `${formattedPrice.slice(1)} TL`;
  }
  return price;
};

export const formatFilterPrice = (value, unit, lang = "it-IT") => {
  if (value && lang !== "tr-TR") {
    const formattedPrice = Intl.NumberFormat(lang, {
      style: "currency",
      currency: unit,
    }).format(value);
    return formattedPrice;
  }
  if (value && lang === "tr-TR") {
    const formattedPrice = Intl.NumberFormat(lang, {
      style: "currency",
      currency: unit,
    }).format(value);
    return `${formattedPrice.slice(1)} TL`;
  }
  return value;
};
